export enum SubmenuType {
  TYPE,
  OPTIONS,
  CURRENCY,
  DATE_FORMAT,
  DATE_FORMAT_SEPARATOR,
  HORIZONTAL_PADDING,
  TIME_FORMAT,
  VERTICAL_PADDING,
  ASPECT_RATIO,
  TEXT_INPUT_NUMBER_PREFIX,
  TEXT_INPUT_NUMBER_SUFFIX,
  TEXT_INPUT_NUMBER_SEPARATOR,
  FRONTMATTER_KEY,
}
